import "../../Styles/ClientSetupStepper.css";

function ClientSetupStepper({
  currentStep,
  selectedRelationFrClient,
  parent,
}) {
  return (
    <div className="client-setup-stepper-wrapper">

      {/* STEP 1 */}
      <div
        className={`client-setup-step-box ${
          currentStep >= 1
            ? "client-setup-active-step"
            : ""
        }`}
      >
        Profile details
      </div>

      <div className="client-setup-step-line-div"></div>

      {/* STEP 2 */}
      <div
        className={`client-setup-step-box ${
          currentStep >= 2
            ? "client-setup-active-step"
            : ""
        }`}
      >
        Payment
      </div>

      {/* SELF ONLY */}
      {selectedRelationFrClient !== parent && (
        <>
          <div className="client-setup-step-line-div"></div>

          <div
            className={`client-setup-step-box ${
              currentStep >= 3
                ? "client-setup-active-step"
                : ""
            }`}
          >
            Match Preferences
          </div>
        </>
      )}
    </div>
  );
}

export default ClientSetupStepper;